// @flow
import { Grid } from 'semantic-ui-react';
import { CommittedCapacityMetricNameDropdownContainerForEstimateCC } from '@components/committed-capacity/CommittedCapacityMetricNameDropdownContainerForEstimateCC';
import React from 'react';

export const AddMetricNameDropdownRowForEstimateCC = ({ index, metricDimensionRefs, row }) => (
  <Grid.Row>
    <Grid.Column width={3}>
      <CommittedCapacityMetricNameDropdownContainerForEstimateCC
        dimensionsArrayHelpers={
          metricDimensionRefs.current.dimensionArrayHelpersMap[row.metricName]
        }
        index={index}
        row={row}
      />
    </Grid.Column>
  </Grid.Row>
);
